/**
 * slick carousel
 */
import $ from 'jquery';
import 'slick-carousel';
import "slick-carousel/slick/slick.css";
//import "slick-carousel/slick/slick-theme.css";

export default () => {
  const Slick = () => {

    $(document).ready(function() {
      enableSlick();
    });

    $(window).on("resize", function (e) {
      enableSlick();
    });

    function enableSlick() {
      var newWindowWidth = $(window).width();
      if (newWindowWidth < 600) {      
        $('.wagner-recent-posts .post-area .posts-container, .wagner-recent-projects .nectar-post-grid').not('.slick-initialized').slick({
          slidesToShow: 1,
          slideToScroll: 1,
          arrows: false,
          dots: true,
          adaptiveHeight: false,
          mobileFirst: true,
          autoplay: true,
          autoplaySpeed: 9000,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      }
    }
  };
  Slick();
};